function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { checkIsTizenVersion, DeviceType, SamsungFw, TizenVersion } from '@sky-uk-ott/client-lib-js-device';
import { createProviderFromAdInsertionConfig, createVacFreewheelProvider, shouldLoadAdvertisingAddons } from '../../addons/adverts/ad-provider-selection';
import { YospaceEnvironment } from '../../addons/adverts/server-adverts/yospace/yospace-config';
import { AdsConfigProvider, VodAdvertsAddonType } from '../../addons/adverts/vod-adverts/base';
import { loadAddon } from '../../addons/loader/addon-load';
import { TestingOverrides } from '../../core/services/testing-overrides';
import { sdkLogger } from '../../logger';
import { getLgWebOsVersion } from '../../utils/device-type';
import { PerfKey, perfLogger, PerfTag } from '../../utils/perf';
import { checkIsManifestLinearType } from '../../utils/playback-type';
import { shouldUseMediaTailor } from './ad-insertion-selection';
import { overrideAdInsertionFactory } from '../testing-overrides/ad-insertion/override-factories';
import { importMediaTailor, importMultiPlayerCsai } from './ad-insertion-imports';
export function loadWebOsFactory(device, adInsertionConfig) {
    return _loadWebOsFactory.apply(this, arguments);
}
function _loadWebOsFactory() {
    _loadWebOsFactory = _async_to_generator(function(device, adInsertionConfig) {
        var webOSVersion, _ref, // legacy LG webOS
        TimelineAdvertsAddon, vmapProviderModule;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    webOSVersion = getLgWebOsVersion(device.deviceInfo);
                    if (!webOSVersion) {
                        sdkLogger.warn('Invalid WebOS Version, cannot elect a Advertisement Addon');
                        // @ts-ignore
                        return [
                            2
                        ];
                    }
                    if (!(webOSVersion <= 3)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        importMultiPlayerCsai()
                    ];
                case 1:
                    _ref = _state.sent(), TimelineAdvertsAddon = _ref.TimelineAdvertsAddon, vmapProviderModule = _ref.vmapProviderModule;
                    return [
                        2,
                        function(adInsertionSessionData) {
                            var sessionItem = adInsertionSessionData.sessionItem, sessionAdEvents = adInsertionSessionData.sessionAdEvents, pauseAdvertDispatcher = adInsertionSessionData.pauseAdvertDispatcher, _$adInsertionConfig = adInsertionSessionData.adInsertionConfig, playoutData = adInsertionSessionData.playoutData;
                            if (!shouldLoadAdvertisingAddons(sessionItem)) {
                                return;
                            }
                            return loadAddon(PerfKey.multiPlayerCsai, function() {
                                var _ref = (_$adInsertionConfig === null || _$adInsertionConfig === void 0 ? void 0 : _$adInsertionConfig.multiPlayerCsai) || {}, type = _ref.type, adsConfigProvider = _ref.adsConfigProvider;
                                var shouldUseLocalProviderConfigVmapAddon = type === VodAdvertsAddonType.VMAP && adsConfigProvider === AdsConfigProvider.Local;
                                if (shouldUseLocalProviderConfigVmapAddon || TestingOverrides.multiPlayerCsaiOverride.staticOverride) {
                                    var _sessionItem_user_ids_freewheel, _sessionItem_user_ids, _sessionItem_user;
                                    var provider = createProviderFromAdInsertionConfig(_$adInsertionConfig.multiPlayerCsai, vmapProviderModule, ((_sessionItem_user = sessionItem.user) === null || _sessionItem_user === void 0 ? void 0 : (_sessionItem_user_ids = _sessionItem_user.ids) === null || _sessionItem_user_ids === void 0 ? void 0 : (_sessionItem_user_ids_freewheel = _sessionItem_user_ids.freewheel) === null || _sessionItem_user_ids_freewheel === void 0 ? void 0 : _sessionItem_user_ids_freewheel.profileid) || '');
                                    return new TimelineAdvertsAddon(provider, sessionAdEvents, sessionItem.type, pauseAdvertDispatcher, playoutData);
                                }
                                if (type === VodAdvertsAddonType.VMAP && adsConfigProvider === AdsConfigProvider.Vam) {
                                    var provider1 = createVacFreewheelProvider(vmapProviderModule);
                                    return new TimelineAdvertsAddon(provider1, sessionAdEvents, sessionItem.type, pauseAdvertDispatcher, playoutData);
                                }
                            });
                        }
                    ];
                case 2:
                    return [
                        2,
                        loadBaseFactory(device, adInsertionConfig)
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _loadWebOsFactory.apply(this, arguments);
}
export function loadBaseFactory(device, adInsertionConfig) {
    return _loadBaseFactory.apply(this, arguments);
}
function _loadBaseFactory() {
    _loadBaseFactory = _async_to_generator(function(device, adInsertionConfig) {
        var _adInsertionConfig_mediaTailor, MediaTailorAddon;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        importMediaTailor(adInsertionConfig === null || adInsertionConfig === void 0 ? void 0 : (_adInsertionConfig_mediaTailor = adInsertionConfig.mediaTailor) === null || _adInsertionConfig_mediaTailor === void 0 ? void 0 : _adInsertionConfig_mediaTailor.deriveAdInfoFromManifest)
                    ];
                case 1:
                    MediaTailorAddon = _state.sent().MediaTailorAddon;
                    return [
                        2,
                        function(adInsertionSessionData) {
                            var sessionItem = adInsertionSessionData.sessionItem, sessionAdEvents = adInsertionSessionData.sessionAdEvents, pauseAdvertDispatcher = adInsertionSessionData.pauseAdvertDispatcher, companionAdvertDispatcher = adInsertionSessionData.companionAdvertDispatcher, _$adInsertionConfig = adInsertionSessionData.adInsertionConfig;
                            if (!shouldLoadAdvertisingAddons(sessionItem)) {
                                return;
                            }
                            if (_$adInsertionConfig.yospace) {
                                sdkLogger.warn('Yospace addon is getting deprecated. Its configuration should be removed for all devices except Playstation (Webmaf) and AndroidTV which still requires it.');
                            }
                            return loadAddon(PerfKey.mediaTailor, function() {
                                return new MediaTailorAddon(_$adInsertionConfig.mediaTailor, sessionAdEvents, pauseAdvertDispatcher, companionAdvertDispatcher, sessionItem);
                            });
                        }
                    ];
            }
        });
    });
    return _loadBaseFactory.apply(this, arguments);
}
export function loadWithYospaceFallback(device, adInsertionConfig) {
    return _loadWithYospaceFallback.apply(this, arguments);
}
function _loadWithYospaceFallback() {
    _loadWithYospaceFallback = _async_to_generator(function(device, adInsertionConfig) {
        var _adInsertionConfig_mediaTailor, deviceType, deriveAdInfoFromManifest, _ref, _ref_, YospaceAddon, generateGenericYospaceUrl, MediaTailorAddon;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    deviceType = device.type;
                    deriveAdInfoFromManifest = adInsertionConfig === null || adInsertionConfig === void 0 ? void 0 : (_adInsertionConfig_mediaTailor = adInsertionConfig.mediaTailor) === null || _adInsertionConfig_mediaTailor === void 0 ? void 0 : _adInsertionConfig_mediaTailor.deriveAdInfoFromManifest;
                    return [
                        4,
                        Promise.all([
                            importYospace(),
                            importMediaTailor(deriveAdInfoFromManifest)
                        ])
                    ];
                case 1:
                    _ref = _sliced_to_array.apply(void 0, [
                        _state.sent(),
                        2
                    ]), _ref_ = _ref[0], YospaceAddon = _ref_.YospaceAddon, generateGenericYospaceUrl = _ref_.generateGenericYospaceUrl, MediaTailorAddon = _ref[1].MediaTailorAddon;
                    return [
                        2,
                        function(adInsertionSessionData) {
                            var sessionItem = adInsertionSessionData.sessionItem, sessionAdEvents = adInsertionSessionData.sessionAdEvents, pauseAdvertDispatcher = adInsertionSessionData.pauseAdvertDispatcher, companionAdvertDispatcher = adInsertionSessionData.companionAdvertDispatcher, _$adInsertionConfig = adInsertionSessionData.adInsertionConfig, playoutData = adInsertionSessionData.playoutData;
                            if (!shouldLoadAdvertisingAddons(sessionItem)) {
                                return;
                            }
                            if (shouldUseMediaTailor(_$adInsertionConfig, sessionItem.type, deviceType, playoutData)) {
                                return loadAddon(PerfKey.mediaTailor, function() {
                                    return new MediaTailorAddon(_$adInsertionConfig.mediaTailor, sessionAdEvents, pauseAdvertDispatcher, companionAdvertDispatcher, sessionItem);
                                });
                            }
                            if (deviceType === DeviceType.Android && !checkIsManifestLinearType(sessionItem.type)) {
                                return;
                            }
                            return loadAddon(PerfKey.yospace, function() {
                                var _TestingOverrides_yospaceOverride, _adInsertionConfig_yospace, _sessionItem_adInsertion_yospace, _sessionItem_adInsertion, _sessionItem_user_ids_yospace, _sessionItem_user_ids, _sessionItem_user;
                                var yospaceEnvironment = ((_TestingOverrides_yospaceOverride = TestingOverrides.yospaceOverride) === null || _TestingOverrides_yospaceOverride === void 0 ? void 0 : _TestingOverrides_yospaceOverride.environment) || YospaceEnvironment.PRODUCTION;
                                var config = _object_spread_props(_object_spread({}, _$adInsertionConfig.yospace), {
                                    debug: ((_adInsertionConfig_yospace = _$adInsertionConfig.yospace) === null || _adInsertionConfig_yospace === void 0 ? void 0 : _adInsertionConfig_yospace.debug) || (sessionItem === null || sessionItem === void 0 ? void 0 : (_sessionItem_adInsertion = sessionItem.adInsertion) === null || _sessionItem_adInsertion === void 0 ? void 0 : (_sessionItem_adInsertion_yospace = _sessionItem_adInsertion.yospace) === null || _sessionItem_adInsertion_yospace === void 0 ? void 0 : _sessionItem_adInsertion_yospace.debug),
                                    userId: ((_sessionItem_user = sessionItem.user) === null || _sessionItem_user === void 0 ? void 0 : (_sessionItem_user_ids = _sessionItem_user.ids) === null || _sessionItem_user_ids === void 0 ? void 0 : (_sessionItem_user_ids_yospace = _sessionItem_user_ids.yospace) === null || _sessionItem_user_ids_yospace === void 0 ? void 0 : _sessionItem_user_ids_yospace.profileid) || '',
                                    environment: yospaceEnvironment,
                                    deviceType: deviceType
                                });
                                return new YospaceAddon(config, sessionAdEvents, generateGenericYospaceUrl, sessionItem, pauseAdvertDispatcher);
                            });
                        }
                    ];
            }
        });
    });
    return _loadWithYospaceFallback.apply(this, arguments);
}
export function loadTizenFactory(device, adInsertionConfig) {
    return _loadTizenFactory.apply(this, arguments);
}
function _loadTizenFactory() {
    _loadTizenFactory = _async_to_generator(function(device, adInsertionConfig) {
        var deviceInfo, samsungFwVersion, isTizen5Dot5, loadBaseFn;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    deviceInfo = device.deviceInfo;
                    samsungFwVersion = new SamsungFw(deviceInfo.deviceFirmware);
                    isTizen5Dot5 = checkIsTizenVersion(deviceInfo, TizenVersion['Tizen-5.5']);
                    return [
                        4,
                        loadBaseFactory(device, adInsertionConfig)
                    ];
                case 1:
                    loadBaseFn = _state.sent();
                    return [
                        2,
                        function(adInsertionSessionData) {
                            var sessionItem = adInsertionSessionData.sessionItem;
                            var MIN_SAMSUNG_FW_FOR_ADS = new SamsungFw(sessionItem.minimumSamsungSdkVersion ? '2014.1' : '2016.1');
                            if (checkIsManifestLinearType(sessionItem.type) && isTizen5Dot5 && !samsungFwVersion.isNewerOrEqualTo(MIN_SAMSUNG_FW_FOR_ADS)) {
                                sdkLogger.withContext('PeacockTizenFactory').info("Disabling ads for Tizen 5.5 with firmware version ".concat(deviceInfo.deviceFirmware));
                                return;
                            }
                            return loadBaseFn(adInsertionSessionData);
                        }
                    ];
            }
        });
    });
    return _loadTizenFactory.apply(this, arguments);
}
export var getFactoryLoader = function(param) {
    var device = param.device, proposition = param.proposition, advertsMapping = param.advertsMapping, adInsertionConfig = param.adInsertionConfig, adInsertionLogger = param.adInsertionLogger;
    if (TestingOverrides.adInsertionOverride) {
        return overrideAdInsertionFactory(proposition, device.type, adInsertionConfig);
    }
    var factoryLoader = advertsMapping[device.type];
    if (!factoryLoader) {
        adInsertionLogger.error("No ad insertion available for device: ".concat(device.type));
        return;
    }
    return factoryLoader(device, adInsertionConfig);
};
function importYospace() {
    return _importYospace.apply(this, arguments);
}
function _importYospace() {
    _importYospace = _async_to_generator(function() {
        var _ref, generateGenericYospaceUrl, YospaceAddon;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    perfLogger.measure(PerfKey.yospace, PerfTag.addonLoadStart);
                    return [
                        4,
                        import(/* webpackChunkName: "sdk-ad-yo" */ '../../addons/adverts/server-adverts/yospace/yospace')
                    ];
                case 1:
                    _ref = _state.sent(), generateGenericYospaceUrl = _ref.generatePeacockYospaceUrl, YospaceAddon = _ref.YospaceAddon;
                    perfLogger.measure(PerfKey.yospace, PerfTag.addonLoadEnd);
                    return [
                        2,
                        {
                            generateGenericYospaceUrl: generateGenericYospaceUrl,
                            YospaceAddon: YospaceAddon
                        }
                    ];
            }
        });
    });
    return _importYospace.apply(this, arguments);
}

//# sourceMappingURL=ad-insertion-factories.js.map